import React, { useState, useEffect } from "react";
import Sidebar from "../../components/layout/Sidebar/Sidebar";
import Header from "../../components/layout/Header/Header";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer/Footer";

const Layout = ({ children, isAuthenticated }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
  const navigate = useNavigate();

  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    // Only force login when unauthenticated. Do not re-navigate to the
    // current path — that fights permission redirects (e.g. /stock-upload → /404).
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar className="hidden md:block"  />
      <div className="flex flex-col flex-1 w-2/3">
        <Header onMenuClick={toggleSidebar} />
        <main className="flex-1 p-4 bg-gray-50 overflow-auto">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;